/**
 * Canonical license plate normalization (DEV-215).
 *
 * German district codes may contain umlauts (RÜD, GÖ, TÜ, FÜS …), but the
 * canonical stored form is the ASCII transliteration (RÜD → RUED) — it matches
 * rental-company fleet exports and avoids encoding drift across systems.
 * The backend applies the same rule in Vehicle::setLicensePlateAttribute.
 */
export function transliterateUmlauts(value: string): string {
  return value
    .replace(/Ä/g, 'AE')
    .replace(/Ö/g, 'OE')
    .replace(/Ü/g, 'UE')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'SS')
}

/** Uppercase + transliterate — the shape every plate input/scan must emit. */
export function normalizePlateInput(value: string): string {
  return transliterateUmlauts(value.toUpperCase())
}
